/* eslint-disable react/prop-types */
import { createContext, useContext, useRef } from "react";

const ClickSoundContext = createContext();

export const ClickSoundProvider = ({ children }) => {
  const audioRef = useRef(new Audio("/audio/click1.wav"));

  const playClick = () => {
    const audio = audioRef.current;
    audio.currentTime = 0;
    audio.play().catch(() => {});
  };

  return (
    <ClickSoundContext.Provider value={{ playClick }}>
      {children}
    </ClickSoundContext.Provider>
  );
};

// Custom hook
export const useClickSound = () => useContext(ClickSoundContext);
